@if (bulkShare) {
  <div class="accountEditShare accountEditShare__bulk">
    <div class="sharesHeaders__site">
      {{ 'edit_multiple' | ppTranslate }}
      <pp-icon
        [ppSrc]="EIconPath.ICON_BADGE_INFO"
        ppColor="inherit"
        ppClass="setSize14"
        ppTooltip
        [ppTitle]="'edit_multiple_shares_tooltip' | ppTranslate"
      ></pp-icon>
    </div>
    <pp-account-user-modal-shares-list-share-access
      [(ppShare)]="bulkShare"
      (ppShareChange)="updateShareRole()"
      [ppHideAsterisk]="true"
    ></pp-account-user-modal-shares-list-share-access>
    @if (ppShowBulkAccessibleTags) {
      <pp-account-user-modal-shares-list-share-accessible-tags
        [(ppShare)]="bulkShare"
        [ppWorkspaceId]="ppWorkspaceId"
        (ppShareChange)="updateShareAccessibleTags()"
        [ppDisabled]="isDisabledForAdmin"
      ></pp-account-user-modal-shares-list-share-accessible-tags>
    }
    @if (!ppShowBulkAccessibleTags) {
      <div class="sharesHeaders__accessibleTags"></div>
    }
    <pp-account-user-modal-shares-list-share-tags
      [(ppShare)]="bulkShare"
      (ppShareChange)="updateShareTags()"
      [ppDisabled]="isDisabledForAdmin"
      [ppShareOption]="bulkShare.shareOption"
    ></pp-account-user-modal-shares-list-share-tags>
    <pp-account-user-modal-shares-list-share-activity
      [(ppShare)]="bulkShare"
      [ppShareOption]="bulkShare.shareOption"
      (ppShareChange)="updateShareActivity()"
      [ppDisabled]="isDisabledForAdmin"
    ></pp-account-user-modal-shares-list-share-activity>
    <pp-account-user-modal-shares-list-share-exports
      [(ppShare)]="bulkShare"
      (ppShareChange)="updateShareExports()"
      [ppDisabled]="isDisabledForAdmin"
    ></pp-account-user-modal-shares-list-share-exports>
    <pp-account-user-modal-shares-list-share-flags
      [(ppShare)]="bulkShare"
      (ppShareChange)="updateShareFlags()"
      [ppDisabled]="isDisabledForAdminAndLimited"
    ></pp-account-user-modal-shares-list-share-flags>

    @if (relatedPointsFlagEnabled) {
      <pp-account-user-modal-shares-list-share-relationships
        data-testid="bulk-share-relationships"
        [(ppShare)]="bulkShare"
        (ppShareChange)="updateShareRelationships()"
        [ppDisabled]="isDisabledForAdminAndLimited"
      ></pp-account-user-modal-shares-list-share-relationships>
    }
    <pp-account-user-modal-shares-list-share-comments
      [(ppShare)]="bulkShare"
      (ppShareChange)="updateShareComments()"
      [ppDisabled]="isDisabledForAdmin"
    ></pp-account-user-modal-shares-list-share-comments>
    @if (ppShowBulkAccessibleTags) {
      <pp-account-user-modal-shares-list-share-custom-fields
        (ppEditCustomFields)="showCustomFieldsTable()"
        [ppUserRole]="bulkShare.shareOption"
        [ppDisabledByCustomFields]="customFieldsCount === 0"
      ></pp-account-user-modal-shares-list-share-custom-fields>
    }
  </div>
}
